export interface IValidateIfUserExists {
  password: string;
  userExistsInCurrentCompany: boolean;
  userExists: boolean;
  userId: number;
}

export class ValidateIfUserExists implements IValidateIfUserExists {
  password: string = "";
  userExistsInCurrentCompany: boolean = false;
  userExists: boolean = false;
  userId: number = 0;
}
